import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import ClearIcon from "@material-ui/icons/Clear";
import * as Dati from "../../Dati";
import { Trad } from "../../components/";

const useStyles = makeStyles({
    selectAdornment: {
        position: "absolute",
        padding: 0,
        right: "20px"
    },
    clearBtn: {
        fontSize: "14px"
    }
});

interface ISelectProps {
    Label: string;
    Name: string;
    OnChange: (e: string, val: string) => void;
    Options: Dati.TDictTipo;
    Value: string | number;
    Disabled?: boolean;
    Permissions?: boolean;
    TranslationsOff?: boolean;
}

export const _Select: React.FC<ISelectProps> = ({ Disabled, Label, Name, Options, Value, OnChange, Permissions, TranslationsOff }) => {
    const classes = useStyles();

    const getPermittedOptions = (options: Dati.TDictTipo): Dati.TDictTipo => {
        let permittedOptions: Dati.TDictTipo = {};

        for (let option in options) {
            if (!options[option].Permesso || (options[option].Permesso || []).indexOf(Value.toString()) >= 0 || options[option].ID_Chiave == Value) {
                permittedOptions[option] = options[option];
            }
        }

        return permittedOptions;
    };

    const permittedOptions = Permissions ? useMemo(() => getPermittedOptions(Options), [Options, Value]) : Options;

    return (
        <TextField
            value={Value}
            name={Name}
            label={Trad.Trad(Label)}
            disabled={Disabled}
            onChange={e => OnChange(e.target.name, e.target.value)}
            InputProps={{
                endAdornment: !Permissions && !Disabled && !!Value && (
                    <InputAdornment position="end" className={classes.selectAdornment}>
                        <Grid container>
                            <IconButton aria-label="clear" onClick={() => OnChange(Name, "")} onMouseDown={e => e.preventDefault()} size="small" className={classes.clearBtn}>
                                <ClearIcon fontSize="inherit" />
                            </IconButton>
                        </Grid>
                    </InputAdornment>
                )
            }}
            fullWidth
            select
        >
            {Object.keys(permittedOptions).map(option => (
                <MenuItem key={permittedOptions[option].ID_Chiave} value={permittedOptions[option].ID_Chiave}>
                    {TranslationsOff ? permittedOptions[option].Valore : Trad.Trad(permittedOptions[option].Valore)}
                </MenuItem>
            ))}
        </TextField>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/form/Select.tsx